'use client';
import { version } from 'pdfjs-dist';
import { Box } from '@chakra-ui/react';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { useEffect, useRef, useState } from 'react';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';

import { useMobileDevice } from 'shared/hooks';

import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PdfViewerPageTemplate = ({ pdfUrl }) => {
  const zoom = zoomPlugin();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const containerRef = useRef(null);
  const { isDesktopDevice } = useMobileDevice();
  const [docLoaded, setDocLoaded] = useState(false);

  // Сделано потому что некоторые pdf самостоятельно,
  // бесконтрольно при загрузке уменьшались в масштабе до нуля
  useEffect(() => {
    if (!docLoaded || !containerRef.current || isDesktopDevice) return;

    const rect = containerRef.current.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      // После загрузки документа и измерения контейнера пробуем PageFit
      zoom.zoomTo(SpecialZoomLevel.PageFit);
    }
  }, [docLoaded, isDesktopDevice]);

  return (
    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.js`}>
      <Box ref={containerRef} w="full" h="100vh" overflow="hidden" pos="relative" zIndex="2000">
        <Viewer
          fileUrl={pdfUrl}
          defaultScale={isDesktopDevice ? 1.5 : SpecialZoomLevel.PageWidth}
          onDocumentLoad={() => setDocLoaded(true)}
          plugins={[defaultLayoutPluginInstance, zoom]}
        />
      </Box>
    </Worker>
  );
};

export default PdfViewerPageTemplate;
